import React, { Component } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { Space, Radio,message, Spin } from "antd";
import Bridge from "../../../utils/Bridge";

export default class ThankYou extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      if_agree_to_participate_in_study: "",
      if_you_no_question_and_agree_status:"",
      participation_attestation:"",
      field_data:[]
    };
  }
  componentDidMount() {
  }
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a href="/update-alsfrs-and-roads" className="back-arrow w-fit-content">
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    Back
                  </a>
                  <div>
                    <div className="header">
                      <h3 className="text-uppercase">Thank You</h3>
                      <div className="white-block"></div>
                    </div>
                    <div className="form-fields">
                        <h5 className="text-uppercase pb-2 pt-2">Thank You!</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
